import React, {useCallback, useState} from 'react';
import intl from "react-intl-universal";

import {useUserState} from "@stores/AppStateContext";
import {useAuthServices} from "../../../platform/hooks/useServiceCombinations";

import {ClientUser} from "../../../API";

import {Select} from '../../components/form/Select/Select';
import {changeUserRole} from "../../../actions/clientUser/adminUserActions";
import {UserRole} from "@stores/UserSessionState";

export interface UserRoleSelectProps {
    user: ClientUser;
}

export const getUserRoleOptions = () => [
    {
        value: "admin",
        label: intl.get('user-role.admin').d('Admin'),
        description: intl.get('user-role.admin.description').d('Full control over workspace features, user management, and settings.'),
    },
    {
        value: "editor",
        label: intl.get('user-role.editor').d('Editor'),
        description: intl.get('user-role.editor.description').d('Can edit and contribute content, without admin privileges.'),
    },
    {
        value: "reader",
        label: intl.get('user-role.reader').d('Reader'),
        description: intl.get('user-role.reader.description').d('Read-only access to view all content without the ability to edit or delete.'),
    },
];

export const UserRoleSelect = (
    {
        user,
    }: UserRoleSelectProps
) => {
    const userState = useUserState();
    const userRoles = getUserRoleOptions();
    const currentRole = userState!.getUserRole(user);
    const authServices = useAuthServices();

    const [selectedUserRole, setSelectedUserRole] = useState<string | null>(currentRole);

    const _changeUserRole = useCallback((value: string | null) => {
        if (value === null) {
            return
        }
        setSelectedUserRole(value ? value : null);
        changeUserRole(
            authServices,
            {
                targetSub: user.sub,
                targetRole: value as UserRole,
            })
    }, [])

    return (
        <Select
            size={"medium"}
            fontSize={'body-large'}
            selectedValue={selectedUserRole}
            onChange={_changeUserRole}
            options={userRoles}
            isFullWidth={true}
            iconSize={20}
            maxWidth={240}
            ignoreActiveHighlight={true}
        />
    )
}
